import React, { useEffect, useState } from "react";
import CommonSelectDropDownTag from "../../../../components/common/datatable/filter/CommonSelectDropDownTag";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

interface ReportTypeProps {
    type: string;
    setType: (type: string) => void;
}

interface ReportTypeEnum {
    constant: string;
    value: string;
}


const ReportType: React.FC<ReportTypeProps> = ({ type, setType }) => {
    const navigate = useNavigate()

    const [reportTypeEnums, setReportTypeEnums] = useState<ReportTypeEnum[]>([]);

    useEffect(() => {
        const reportOptions: ReportTypeEnum[] = [
            hasPermission(["TRNREPO-V"]) && { constant: "TURN_AROUND", value: "Turn Around" },
            hasPermission(["REVREPO-V"]) && { constant: "REVENUE_REPORT", value: "Revenue Report" },
            hasPermission(["CTYREPO-V"]) && { constant: "COUNTY_REPORT", value: "County Report" },
            hasPermission(["AGGUSRREPO-V"]) && { constant: "AGGREGATE_USER_EFFICIENCY_REPORT", value: "Aggregate User Efficiency Report" },
            hasPermission(["DETUSRREPO-V"]) && { constant: "DETAILED_USER_EFFICIENCY_REPORT", value: "Detailed User Efficiency Report" },
            hasPermission(["AUTMUNREPO-V"]) && { constant: "AUTO_VS_MANUAL_REPORT", value: "Auto vs Manual Report" },
            hasPermission(["ACCRECREPO-V"]) && { constant: "ACCOUNTS_RECEIVABLE_REPORT", value: "Accounts Receivable Report" },
            hasPermission(["FCANDR-V"]) && { constant: "FULFILLMENT_CANDIDATE_REPORT", value: "Fulfillment Candidate Report" },
            hasPermission(["FCUSR-V"]) && { constant: "FULFILLMENT_CUSTOMER_REPORT", value: "Fulfillment Customer Report" },
            hasPermission(["DLYCUNTREPO-V"]) && { constant: "DAILY_ORDER_COUNT", value: "Daily Order Count" },
            hasPermission(["DLYUPDREPO-V"]) && { constant: "DAILY_UPDATE_REPORT", value: "Daily Update Report" },
            hasPermission(["PAR-V"]) && { constant: "PRODUCT_ASSIGNMENT_REPORT", value: "Product Assignment Report" }
        ].filter(Boolean) as ReportTypeEnum[]; // Remove falsy values

        setReportTypeEnums(reportOptions);
    }, []);

    useEffect(() => {
        const routes: { [key: string]: string } = {
            TURN_AROUND: `/turn-around-report`,
            REVENUE_REPORT: `/revenue-report`,
            COUNTY_REPORT: `/county-report`,
            AUTO_VS_MANUAL_REPORT: `/auto-vs-manual-report`,
            AGGREGATE_USER_EFFICIENCY_REPORT: `/aggregate-user-efficiency-report`,
            ACCOUNTS_RECEIVABLE_REPORT: `/accounts-receivable-report`,
            DAILY_ORDER_COUNT: "/daily-order-count-report",
            DAILY_UPDATE_REPORT: "/daily-update-report",
            DETAILED_USER_EFFICIENCY_REPORT: `/detailed-user-efficiency-report`,
            FULFILLMENT_CANDIDATE_REPORT: `/fulfillment-candidate-report`,
            FULFILLMENT_CUSTOMER_REPORT: `/fulfillment-customer-report`,
            PRODUCT_ASSIGNMENT_REPORT: "/product-assignment-report",
        };

        if (type && routes[type]) {
            navigate(routes[type])
        }
    }, [type]);


  


    return (
        <div className="row">
            <div className="col-lg-12 ml-auto">
                <div className="flex items-center gap-2 w-full pb-4">
                    <label htmlFor="reportType" className="w-1/4 text-md font-medium text-text-3">
                        Report Type
                    </label>
                    <div className="w-3/4 col-sm-6">
                        <CommonSelectDropDownTag
                            itemMap={reportTypeEnums}
                            label="value"
                            value="constant"
                            placeholderText="Select Report Type..."
                            isMulti={false}
                            name={type} 
                            setName={setType}
                            isRequired={false}
                            isDisabled={false}
                            className="w-3/5"

                        />

                    </div>
                </div>

            </div>
        </div>
    );
};

export default ReportType;
